export const timeOptions = [
  {
    name: "按年",
    value: "年"
  },
  {
    name: "按半年度",
    value: "半年度"
  },
  {
    name: "按季度",
    value: "季度"
  },
  {
    name: "按月",
    value: "月"
  },
  {
    name: "按周",
    value: "周"
  },
  {
    name: "按日",
    value: "日"
  },
  {
    name: "按小时",
    value: "小时"
  },
  {
    name: "自定义",
    value: "自定义"
  }
]

export const timeMap = {
  上半年: "01-01 00:00:00",
  下半年: "07-01 00:00:00",
  第一季度: "01-01 00:00:00",
  第二季度: "04-01 00:00:00",
  第三季度: "07-01 00:00:00",
  第四季度: "10-01 00:00:00"
}

export const areaOptions = [
  // {
  //   name: "国家",
  //   value: "国家"
  // },
  {
    name: "按省",
    value: "省"
  },
  {
    name: "按市",
    value: "市"
  },
  {
    name: "按区",
    value: "区"
  }
  // {
  //   name: "街道",
  //   value: "街道"
  // }
]

export const yOptions = [
  {
    name: "计数",
    value: "计数"
  },
  // {
  //   name: "去重计数",
  //   value: "去重计数"
  // },
  {
    name: "求和",
    value: "求和"
  },
  {
    name: "平均值",
    value: "平均值"
  },
  {
    name: "最大值",
    value: "最大值"
  },
  {
    name: "最小值",
    value: "最小值"
  }
  // {
  //   name: "中位数",
  //   value: "中位数"
  // },
  // {
  //   name: "百分位",
  //   value: "百分位"
  // },
  // {
  //   name: "总体标准差",
  //   value: "总体标准差"
  // },
  // {
  //   name: "样本标准差",
  //   value: "样本标准差"
  // },
  // {
  //   name: "总体方差",
  //   value: "总体方差"
  // },
  // {
  //   name: "样本方差",
  //   value: "样本方差"
  // }
]

export const chartList = [
  {
    name: "柱状图",
    value: "basic-bar",
    disabled: false
  },
  {
    name: "堆叠柱",
    value: "stacked-basic-bar",
    disabled: false
  },
  {
    name: "条形图",
    value: "bar",
    disabled: false
  },
  {
    name: "堆叠条",
    value: "stacked-bar",
    disabled: false
  },
  {
    name: "折线图",
    value: "line",
    disabled: false
  },
  {
    name: "曲线图",
    value: "smoothed-line",
    disabled: false
  },
  {
    name: "面积图",
    value: "area-chart",
    disabled: false
  },
  {
    name: "环形图",
    value: "ring-diagram",
    disabled: false
  },
  {
    name: "饼状图",
    value: "pie",
    disabled: false
  },
  {
    name: "漏斗图",
    value: "funnel",
    disabled: false
  },
  {
    name: "指标",
    value: "indicator",
    disabled: false
  },
  {
    name: "交叉表",
    value: "cross-table",
    disabled: false
  },
  {
    name: "地图",
    value: "map",
    disabled: false
  }
]

export const chartMap = {
  "basic-bar": {
    name: "柱状图",
    value: "basic-bar"
  },
  "stacked-basic-bar": {
    name: "堆叠柱",
    value: "basic-bar"
  },
  bar: {
    name: "条形图",
    value: "bar"
  },
  "stacked-bar": {
    name: "堆叠条",
    value: "stacked-bar"
  },
  line: {
    name: "折线图",
    value: "line"
  },
  "smoothed-line": {
    name: "曲线图",
    value: "smoothed-line"
  },
  "area-chart": {
    name: "面积图",
    value: "area-chart"
  },
  "ring-diagram": {
    name: "环形图",
    value: "ring-diagram"
  },
  pie: {
    name: "饼状图",
    value: "pie"
  },
  indicator: {
    name: "指标",
    value: "indicator"
  },
  funnel: {
    name: "漏斗图",
    value: "funnel"
  },
  "cross-table": {
    name: "交叉表",
    value: "cross-table"
  },
  map: {
    name: "地图",
    value: "map"
  },
  query: {
    name: "查询",
    value: "query"
  }
}

export const chartMenus = [
  {
    name: "基本信息"
  },
  {
    name: "样式配置"
  }
]

export const groupTypeList = [
  {
    label: "计数",
    value: "COUNT"
  },
  {
    label: "非空计数",
    value: "NOT_NULL_COUNT"
  },
  {
    label: "去重计数",
    value: "DISTINCT_COUNT"
  },
  {
    label: "求和",
    value: "SUM"
  },
  {
    label: "平均值",
    value: "AVG"
  },
  {
    label: "最大值",
    value: "MAX"
  },
  {
    label: "最小值",
    value: "MIN"
  }
]

export const dataFormatList = [
  {
    label: "自动",
    value: "AUTO"
  },
  {
    label: "整数",
    value: "INTEGER"
  },
  {
    label: "保留1位小数",
    value: "ONE_DECIMAL"
  },
  {
    label: "保留2位小数",
    value: "TWO_DECIMAL"
  },
  {
    label: "保留3位小数",
    value: "THREE_DECIMAL"
  },
  {
    label: "保留4位小数",
    value: "FOUR_DECIMAL"
  },
  {
    label: "百分比",
    value: "PERCENT"
  },
  {
    label: "百分比1位小数",
    value: "PERCENT_ONE"
  },
  {
    label: "百分比2位小数",
    value: "PERCENT_TWO"
  },
  {
    label: "百分比3位小数",
    value: "PERCENT_THREE"
  },
  {
    label: "百分比4位小数",
    value: "PERCENT_FOUR"
  }
]

export const thousandsList = [
  {
    label: "显示千分位",
    value: true
  },
  {
    label: "不显示千分位",
    value: false
  }
]

export const dataCalcList = [
  {
    label: "占父行汇总的百分比",
    value: "PTC"
  },
  {
    label: "占列总计的百分比",
    value: "PTC_ALL"
  },
  {
    label: "同环比",
    value: "THB"
  }
]

export const dataTypeList = [
  { label: "具体数值", value: "VALUE" },
  { label: "对比差值", value: "DIFF" },
  { label: "差值百分比", value: "NORMAL" },
  { label: "比值百分数", value: "RATIO" }
]

export const thbListMap = {
  年: [{ label: "年环比", value: "HB" }],
  半年度: [
    { label: "半年环比", value: "HB" },
    { label: "年同比", value: "年-TB" }
  ],
  季度: [
    { label: "季环比", value: "HB" },
    { label: "年同比", value: "年-TB" }
  ],
  月: [
    { label: "月环比", value: "HB" },
    { label: "年同比", value: "年-TB" }
  ],
  周: [{ label: "周环比", value: "周-HB" }],
  日: [
    { label: "日环比", value: "HB" },
    { label: "周同比", value: "周-TB" },
    { label: "月同比", value: "月-TB" },
    { label: "年同比", value: "年-TB" }
  ]
}

export const operationMap = {
  addQuota: "新建指标",
  editQuota: "编辑指标"
}

export const haiNanRec = {
  type: "Feature",
  properties: {
    name: "",
    adchar: "JD",
    adcode: "100000_JD"
  },
  geometry: {
    type: "MultiPolygon",
    coordinates: [
      [
        [
          [132.5, 20],
          [132.5, 27.5]
        ]
      ],
      [
        [
          [126.5, 27.5],
          [126.5, 20]
        ]
      ],
      [
        [
          [126.5, 27.5],
          [132.5, 27.5]
        ]
      ],
      [
        [
          [126.5, 20],
          [132.5, 20]
        ]
      ]
    ]
  }
}

export const themeMapColor = {
  walden: ["rgb(107, 230, 193)", "rgb(63, 177, 227)", "rgb(160, 167, 230)"],
  vintage: ["rgb(145, 158, 139)", "rgb(215, 171, 130)", "rgb(216, 124, 124)"],
  dark: ["rgb(141, 193, 169)", "rgb(230, 157, 135)", "rgb(221, 107, 102)"],
  westeros: ["rgb(147, 183, 227)", "rgb(89, 196, 230)", "rgb(237, 175, 218)"],
  essos: ["rgb(235, 129, 70)", "rgb(217, 88, 80)", "rgb(137, 52, 72)"],
  wonderland: ["rgb(123, 217, 165)", "rgb(34, 195, 170)", "rgb(208, 100, 138)"],
  chalk: ["rgb(135, 247, 207)", "rgb(114, 204, 255)", "rgb(252, 151, 175)"],
  infographic: ["rgb(252, 206, 16)", "rgb(232, 124, 37)", "rgb(193, 35, 43)"],
  macarons: ["rgb(46, 199, 201)", "rgb(90, 177, 239)", "rgb(255, 185, 128)"],
  roma: ["rgb(245, 232, 200)", "rgb(224, 31, 84)", "rgb(0, 24, 82)"],
  shine: ["rgb(0, 152, 217)", "rgb(43, 130, 29)", "rgb(193, 46, 52)"],
  "purple-passion": ["rgb(224, 152, 199)", "rgb(138, 124, 168)", "rgb(113, 102, 158)"]
}

export const kindList = [
  { label: "固定值", value: "fixed" },
  { label: "动态值", value: "dynamic" }
]

export const calcList = [
  { label: "平均值", value: "average" },
  { label: "最大值", value: "max" },
  { label: "最小值", value: "min" }
]

export const totalMethodList = [
  { label: "求和", value: "SUM" },
  { label: "平均值", value: "AVG" },
  { label: "最大值", value: "MAX" },
  { label: "最小值", value: "MIN" },
  { label: "计数", value: "COUNT" }
]

export const rangeList = [
  { label: "分页数据", value: "PAGE" },
  { label: "全部数据", value: "ALL" }
]

export const lineOperationMap = {
  addLine: "新建辅助线",
  editLine: "编辑辅助线"
}

export const totalOperationMap = {
  addTotal: "新建汇总",
  editTotal: "编辑汇总"
}

export const ruleOperationMap = {
  addRule: "新建规则",
  editRule: "编辑规则"
}

export const colorTypeList = [
  {
    label: "区间色",
    value: "区间色"
  },
  {
    label: "渐变色",
    value: "渐变色"
  },
  {
    label: "数据条",
    value: "数据条"
  }
]

export const colorList = [
  {
    label: "蓝色",
    value: "blue",
    color: ["rgb(194, 218, 242)", "rgb(11, 120, 230)"]
  },
  {
    label: "天蓝",
    value: "skyBlue",
    color: ["rgb(194, 242, 242)", "rgb(20, 158, 204)"]
  },
  {
    label: "红色",
    value: "red",
    color: ["rgb(242, 194, 194)", "rgb(204, 45, 20)"]
  },
  {
    label: "黄色",
    value: "yellow",
    color: ["rgb(242, 234, 194)", "rgb(204, 143, 20)"]
  },
  {
    label: "紫色",
    value: "purple",
    color: ["rgb(214, 194, 242)", "rgb(97, 46, 230)"]
  },
  {
    label: "绿色",
    value: "green",
    color: ["rgb(184, 230, 212)", "rgb(58, 166, 124)"]
  }
]

export const presetColors = [
  {
    background: null,
    color: "#1989FA"
  },
  {
    background: null,
    color: "#3BC285"
  },
  {
    background: null,
    color: "#FD5959"
  },
  {
    background: null,
    color: "#9A59FF"
  },
  {
    background: null,
    color: "#F29530"
  },
  {
    background: "#DDEEFF",
    color: "#1989FA"
  },
  {
    background: "#E2F6ED",
    color: "#3BC285"
  },
  {
    background: "#FFE6E6",
    color: "#FD5959"
  },
  {
    background: "#F0E6FF",
    color: "#9A59FF"
  },
  {
    background: "#FCEAD6",
    color: "#F29530"
  },
  {
    background: "#1989FA",
    color: "#FFFFFF"
  },
  {
    background: "#3BC285",
    color: "#FFFFFF"
  },
  {
    background: "#FD5959",
    color: "#FFFFFF"
  },
  {
    background: "#9A59FF",
    color: "#FFFFFF"
  },
  {
    background: "#F29530",
    color: "#FFFFFF"
  }
]

export const presetDataBarColors = [
  {
    negative: "rgb(59, 194, 133)",
    positive: "rgb(253, 89, 89)"
  },
  {
    negative: "rgb(154, 89, 255)",
    positive: "rgb(242, 149, 48)"
  },
  {
    negative: "rgb(25, 137, 250)",
    positive: "rgb(253, 89, 89)"
  },
  {
    negative: "rgb(242, 149, 48)",
    positive: "rgb(59, 194, 133)"
  },
  {
    negative: "rgb(253, 89, 89)",
    positive: "rgb(154, 89, 255)"
  },
  {
    negative: "rgb(253, 89, 89)",
    positive: "rgb(59, 194, 133)"
  },
  {
    negative: "rgb(242, 149, 48)",
    positive: "rgb(154, 89, 255)"
  },
  {
    negative: "rgb(253, 89, 89)",
    positive: "rgb(25, 137, 250)"
  },
  {
    negative: "rgb(59, 194, 133)",
    positive: "rgb(242, 149, 48)"
  },
  {
    negative: "rgb(154, 89, 255)",
    positive: "rgb(253, 89, 89)"
  }
]

export const methods = [
  {
    label: "<=",
    value: "<="
  },
  {
    label: "<",
    value: "<"
  }
]

export const positionMap = {
  top: {
    left: "center",
    top: "top",
    orient: "horizontal",
    align: "left"
  },
  bottom: {
    left: "center",
    bottom: "5%",
    orient: "horizontal",
    align: "left"
  },
  left: {
    left: "left",
    top: "middle",
    orient: "vertical",
    align: "left"
  },
  right: {
    left: "right",
    top: "middle",
    orient: "vertical",
    align: "left"
  }
}

export const mapPositionMap = {
  top: {
    right: "2%",
    top: "top",
    orient: "horizontal",
    align: "left"
  },
  bottom: {
    right: "2%",
    bottom: "4%",
    orient: "horizontal",
    align: "left"
  },
  left: {
    left: "2%",
    top: "middle",
    orient: "vertical",
    align: "left"
  },
  right: {
    right: "2%",
    top: "middle",
    orient: "vertical",
    align: "left"
  }
}

export const basicVertical = {
  type: "value",
  nameLocation: "center",
  nameRotate: 0,
  nameGap: 36,
  alignTicks: true
}

export const basicXVertical = {
  nameLocation: "center",
  nameRotate: 0,
  nameGap: 36
}

export const sortColor = {
  1: "#FDBD3F",
  2: "#C8CCD1",
  3: "#B28663"
}

export const sortDirectionMap = {
  ASC: 1,
  DESC: -1
}

export const sortIconMap = {
  ASC: "el-icon-top",
  DESC: "el-icon-bottom",
  groupASC: "svgo_sort-asc",
  groupDESC: "svgo_sort-desc"
}

export const menuList = [
  { title: "不排序", command: "NONE" },
  { title: "升序", command: "ASC" },
  { title: "降序", command: "DESC" },
  { title: "组内升序", command: "groupASC" },
  { title: "组内降序", command: "groupDESC" }
]

export const sortMethods = [
  { label: "升序", value: "ASC" },
  { label: "降序", value: "DESC" },
  { label: "组内升序", value: "groupASC" },
  { label: "组内降序", value: "groupDESC" }
]
